export enum ECacheKey {
  loader = 'loader',
  minify = 'minify',
}
